import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import React, { lazy, Fragment, useState } from 'react';
import { makeValidate } from '../../UIKit1/textfield/validators';
import { FormStateChangeNotifier } from '../form';
import { useIsInForm } from '../utils/useIsInForm';
import { Label } from '../label';
import { FieldContainer } from '../utils/FieldContainer';
var AKTextField = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.textfield' */
  '@atlaskit/textfield');
});
var AKErrorMessage = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.ErrorMessage
    };
  });
});
var AKFormField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var AKHelperMessage = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.HelperMessage
    };
  });
});
var isValidType = function isValidType(type) {
  return ['text', 'number', 'email', 'tel', 'password'].includes(type);
};
export var TextField = function TextField(props) {
  var _ref = props.forgeDoc.props,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    name = _ref.name,
    label = _ref.label,
    description = _ref.description,
    placeholder = _ref.placeholder,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    defaultValue = _ref.defaultValue,
    testId = _ref.testId,
    autoComplete = _ref.autoComplete,
    _onChange = _ref.onChange,
    value = _ref.value;
  var validate = makeValidate(isRequired, type);

  // WARNING: for <input type=number> and React, native validation is strange, use type text
  var fieldType = !isValidType(type) || type === 'number' ? 'text' : type;

  // Implement validation of AKFormField when not in a form
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var isInForm = useIsInForm();
  if (!isInForm) {
    return jsx(FieldContainer, null, jsx(Label, {
      name: name,
      isRequired: isRequired,
      label: label
    }), jsx(AKTextField, {
      name: name,
      type: fieldType,
      testId: testId,
      placeholder: placeholder,
      autoComplete: autoComplete,
      defaultValue: defaultValue,
      onChange: function onChange(event) {
        var _validate;
        setErrorMessage((_validate = validate(event.target.value)) !== null && _validate !== void 0 ? _validate : '');
        _onChange === null || _onChange === void 0 || _onChange(
        // AKTextField has the wrong type - remove this type cast if it ever gets fixed
        // to this correct type
        event.target.value);
      },
      value: value,
      isInvalid: !!errorMessage,
      "aria-invalid": errorMessage ? 'true' : 'false',
      "aria-labelledby": "".concat(name, "-label")
    }), errorMessage ? jsx(AKErrorMessage, null, errorMessage) : null, description ? jsx(AKHelperMessage, null, description) : null);
  }
  return jsx(FieldContainer, null, jsx(AKFormField, {
    name: name,
    label: label,
    defaultValue: defaultValue,
    isRequired: isRequired,
    validate: validate
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps;
    var id = fieldProps.id,
      isDisabled = fieldProps.isDisabled,
      isInvalid = fieldProps.isInvalid,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      value = fieldProps.value,
      fieldOnChange = fieldProps.onChange,
      ariaLabelledBy = fieldProps['aria-labelledby'];
    var error = isInvalid ? validate(value) : null;
    return jsx(Fragment, null, jsx(FormStateChangeNotifier, {
      name: name,
      value: value
    }), jsx(AKTextField, {
      type: fieldType,
      testId: testId,
      placeholder: placeholder,
      autoComplete: autoComplete,
      onChange: function onChange(event) {
        fieldOnChange(event);
        _onChange === null || _onChange === void 0 || _onChange(
        // AKTextField has the wrong type - remove this type cast if it ever gets fixed
        // to this correct type
        event.target.value);
      },
      onFocus: onFocus,
      onBlur: onBlur,
      isDisabled: isDisabled,
      id: id,
      isInvalid: isInvalid,
      "aria-labelledby": ariaLabelledBy,
      defaultValue: defaultValue
    }), error ? jsx(AKErrorMessage, null, error) : null, description ? jsx(AKHelperMessage, null, description) : null);
  }));
};